/* CARAVIUM COPILOT PREMIUM V1 - beta paywall */
(function(){
  'use strict';

  const STYLE_ID='cv-copilot-premium-style';
  const LIMIT_PATTERNS=[
    /has alcanzado el límite de preguntas de hoy/i,
    /has utilizado tus consultas gratuitas de hoy/i,
    /daily_limit/i,
    /límite diario/i
  ];

  function addStyles(){
    if(document.getElementById(STYLE_ID)) return;
    const s=document.createElement('style');
    s.id=STYLE_ID;
    s.textContent=`
      .cv-premium-card{padding:8px 2px 4px;color:#0d1b2a}
      .cv-premium-badge{display:inline-flex;align-items:center;gap:6px;padding:6px 10px;border-radius:999px;background:#e7fbf8;color:#087f75;font-size:11px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;margin-bottom:12px}
      .cv-premium-title{font-size:clamp(22px,3vw,30px);line-height:1.12;font-weight:850;margin:0 0 8px;color:#0d1b2a}
      .cv-premium-copy{font-size:15px;line-height:1.55;color:#526171;margin:0 0 16px;max-width:760px}
      .cv-premium-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;margin:0 0 17px}
      .cv-premium-benefit{border:1px solid #dbe7e9;border-radius:14px;padding:13px;background:#f8fbfc;min-height:72px}
      .cv-premium-benefit strong{display:block;font-size:14px;margin-bottom:3px;color:#0d1b2a}
      .cv-premium-benefit span{font-size:12px;line-height:1.35;color:#667584}
      .cv-premium-actions{display:flex;align-items:center;gap:12px;flex-wrap:wrap}
      .cv-premium-cta{appearance:none;border:0;border-radius:12px;padding:12px 17px;background:#18bfae;color:#062d31;font:inherit;font-weight:850;cursor:pointer;box-shadow:0 7px 20px rgba(24,191,174,.18)}
      .cv-premium-note{font-size:12px;color:#7a8792}
      .cv-premium-soon{margin-top:12px;padding:10px 12px;border-radius:10px;background:#eef9f7;color:#176d67;font-size:13px;font-weight:700;display:none}
      @media(max-width:720px){.cv-premium-grid{grid-template-columns:1fr}.cv-premium-benefit{min-height:0}.cv-premium-cta{width:100%}.cv-premium-actions{align-items:stretch}}
    `;
    document.head.appendChild(s);
  }

  function isLimitText(text){ return LIMIT_PATTERNS.some(r=>r.test(text||'')); }

  function render(host){
    if(!host || host.dataset.cvPremium==='1') return;
    host.dataset.cvPremium='1';
    host.innerHTML=`
      <div class="cv-premium-card">
        <div class="cv-premium-badge">✦ CARAVIUM PREMIUM · PRÓXIMAMENTE</div>
        <h3 class="cv-premium-title">Sigue viajando con el Copiloto</h3>
        <p class="cv-premium-copy">Has utilizado tus consultas gratuitas de hoy. CARAVIUM Premium ampliará el acceso al Copiloto y añadirá herramientas avanzadas para preparar mejor cada viaje.</p>
        <div class="cv-premium-grid">
          <div class="cv-premium-benefit"><strong>✦ Más Copiloto</strong><span>Muchas más consultas para descubrir, preguntar y organizar el viaje.</span></div>
          <div class="cv-premium-benefit"><strong>🧭 Rutas inteligentes</strong><span>Planificación avanzada de rutas, paradas y lugares CARAVIUM.</span></div>
          <div class="cv-premium-benefit"><strong>🚐 Ventajas CARAVIUM</strong><span>Funciones Premium y futuras ventajas exclusivas para viajeros.</span></div>
        </div>
        <div class="cv-premium-actions">
          <button type="button" class="cv-premium-cta">Descubrir CARAVIUM Premium</button>
          <span class="cv-premium-note">Estamos preparando el lanzamiento.</span>
        </div>
        <div class="cv-premium-soon" role="status">CARAVIUM Premium estará disponible próximamente. Tu Copiloto gratuito volverá a estar disponible al renovarse el límite diario.</div>
      </div>`;
    const btn=host.querySelector('.cv-premium-cta');
    const note=host.querySelector('.cv-premium-soon');
    btn?.addEventListener('click',()=>{ if(note){note.style.display='block';note.scrollIntoView({behavior:'smooth',block:'nearest'});} });
  }

  function scan(){
    addStyles();
    document.querySelectorAll('.cv-copilot-answer__body, .cv-copilot-answer, [class*="copilot-answer"]').forEach(el=>{
      if(isLimitText(el.textContent)){
        const body=el.matches('.cv-copilot-answer__body')?el:(el.querySelector('.cv-copilot-answer__body')||el);
        render(body);
      }
    });
  }

  const obs=new MutationObserver(scan);
  function init(){scan();obs.observe(document.body,{childList:true,subtree:true,characterData:true});}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
